module.exports = __webpack_public_path__ + "media/src/images/certificates/certificate_verified_frame-c93ebc0231773d0dd0287e36bf78c5a8.png";